import { Fragment, useMemo, useState } from "react";
import { BasicCapsTable } from "../common/BasicCapsTable";
import { useQuery } from "@tanstack/react-query";
import { checkApi } from "../../Authentication/AxiosInstance";
import LoadingPage from "../common/LoadingPage";
import ErrorPage from "../common/ErrorPage";
import DisclaimerBanner from "../common/Disclaimers";
const defaultacademicyear = process.env.REACT_APP_DEFAULTACADEMICYEAR;


export const CapsDates = () => {
  const [error, setError] = useState(null);
  const fetchCRS = async () => {
      try {
          const res = await checkApi.get('/capzone/capsdates/');
          // const res = await checkApi.get(`${API_ENDPOINT}/capzone/capsdates/`);
          const contentType = res.headers["content-type"];
            if (!contentType || !contentType.includes("application/json")) {
              console.error("❌ Not JSON:", res.data);
              setError("Expected JSON, got something else.");
            }
          setError('')
          return res.data;
        } catch (error) {
          console.log(error)
          if (error.response) {
            console.error("Server error response:", error.response);
            setError(`HTTP ${error.response.status}`);
          } else {
            setError("Network or other error:", error.message);
          }
        };
  };

  const { data, status} = useQuery({
    queryKey: ["CRSData"],
    queryFn: fetchCRS,
    throwOnError: false,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  });
  

  const dateFormatFn = (v_date) => {
    return v_date
      ? new Date(v_date).toLocaleDateString("en-IN", { dateStyle: "medium" })
      : "";
  };
  
  const dateRangeCell = (cellValue) => {
    console.log(cellValue)
    if (!cellValue || cellValue === null || cellValue === undefined) return null
    const [startDate, endDate] = cellValue.split('\bto\b');
    console.log(startDate, endDate)
        return (
          <div className="text-base md:text-lg font-medium mb-1">
                {startDate? dateFormatFn(startDate.trim()): ''}
                <p>
                  to
                </p>
                {endDate? dateFormatFn(endDate.trim()): ''}
          </div>
        );
  }
  console.log(data)
  const columns = useMemo(
    () => [
      // {
      //   accessorKey: "capsch_allocationboard",
      //   header: "Allocation Board",
      //   footer: "Allocation Board",
      //   minSize: "250",
      // },
      {
        accessorKey: "capsch_round",
        header: "Round",
        footer: "Round",
        cell: ({row}) => { 
          console.log(row.original.capsch_round)
          return <div className="font-bold text-tertiary-300 mb-2 
                                  text-center rounded-lg py-2 px-3 
                                  text-xl md:text-2xl uppercase 
                                  tracking-wide border-b border-gray-100 pb-2"
                > Round: {row.original.capsch_round}
                </div>
        },
        custom_getActivityStatus: false,
      },
      {
        header: 'Registration Dates',
        accessorFn: (row) => row ? dateFormatFn(row.capsch_seat_date) + '\bto\b' + dateFormatFn(row.capsch_cutoff_date) : '',
        cell: ({ row }) => {
          console.log(row.original.capsch_seat_date, row.original.capsch_cutoff_date)
          const returnValue = dateRangeCell(row.original.capsch_seat_date + '\bto\b' + row.original.capsch_cutoff_date)
          console.log(returnValue)
          return returnValue
        },
        custom_getActivityStatus: true,
      },
      {
        header: "Choice Filling Dates",
        accessorFn: (row) => row ? dateFormatFn(row.capsch_choicefilling_startdate) + '\bto\b' + dateFormatFn(row.capsch_choicefilling_enddate) : '',
        cell: ({ row }) => {
          const returnValue = dateRangeCell(dateFormatFn(row.original.capsch_choicefilling_startdate) + '\bto\b' + dateFormatFn(row.original.capsch_choicefilling_enddate))
          console.log(returnValue)
          return returnValue
        },
        custom_getActivityStatus: true,
      },
     
      {
        accessorFn: (row) => row ? dateFormatFn(row.capsch_seatallotment_date) : '',
        header: "Seat Allotment Date",
        footer: "Seat Allotment Date",
        custom_getActivityStatus: true,
      },
      {
        accessorFn: (row) => row ? dateFormatFn(row.capsch_feepayment_date) : '',
        header: "Pay Fees By",
        footer: "Pay Fees By",
        custom_getActivityStatus: true,
      },
      {
        accessorKey: "capsch_notes",
        header: "Notes",
        footer: "Notes",
        cell: ({ row }) => {
          return <div className="text-base md:text-lg font-medium mb-1">
            {row.original.capsch_notes}
          </div>
        },
        custom_getActivityStatus: false,
      },
    ],
    []
  );

  console.log(data);
  console.log(error)
  return (
    <Fragment>
      {status === "pending" ? (
        <LoadingPage />
      ) : status === "error" ? (
        <ErrorPage/>
      ) : error ? (
        <ErrorPage nodatafound={error}/>
      ) : (
          <div className="w-full overflow-x-hidden p-4">
            <section className="w-full max-w-full mb-6 px-2" aria-label="CAP Schedules Introduction">
              <header className="mb-3">
              <h1 className="text-2xl md:text-3xl font-bold text-primary-900 mb-2 tracking-tight">
                CAP Schedules: MHTCET, COMEDK, JOSAA & CSAB Rounds
              </h1>
              <p className="text-base md:text-lg text-primary-800 leading-relaxed">
                Your one-stop guide to <strong>Centralized Admission Process (CAP)</strong> schedules for engineering admissions. 
                Track <strong>MHTCET</strong> (Maharashtra), <strong>COMEDK</strong> (Karnataka), <strong>JOSAA</strong>, 
                and <strong>CSAB</strong> rounds with updates as they get published.
              </p>
            </header>
          </section>
          <BasicCapsTable data={data} columns={columns} />
          <DisclaimerBanner/>
        </div>
      )}
    </Fragment>
  );
};

